import { Component, HostListener, OnDestroy } from '@angular/core';

import { DocumentFinderService } from '~/services/document-finder.service';

/**
 * SAP Explore · Document Discovery Agent.
 * Hosts the sidebar, the five-step search workflow, the secondary pages and the overlays.
 */
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnDestroy {
    constructor(public df: DocumentFinderService) {}

    public ngOnDestroy(): void {
        this.df.closeAll();
    }

    public onStepSelected(step: number): void {
        this.df.running = false;
        this.df.go(step);
    }

    public closeOverlays(): void {
        this.df.closeAll();
    }

    @HostListener('document:keydown.escape')
    public onEscape(): void {
        this.df.closeAll();
    }
}
